import { LegalPageLayout } from "@/components/LegalPageLayout";
import { COMPANY } from "@/lib/site-data";

export default function Adatkezeles() {
  return (
    <LegalPageLayout
      eyebrow="Adatkezelés"
      title="Adatkezelési tájékoztató"
      hatalyos="2026. június 11-től"
    >
      <p>
        A jelen adatkezelési tájékoztató célja, hogy bemutassa, hogyan kezeli
        a <strong>FORTUNA PONYVA Kft.</strong> a fortunaponyva.hu weboldal
        látogatóinak, valamint az érdeklődőknek és ügyfeleknek a személyes
        adatait.
      </p>
      <p>
        Az adatkezelés során törekszünk arra, hogy az adatkezelés átlátható,
        jogszerű, tisztességes és biztonságos legyen. A személyes adatok
        kezelésére elsősorban az Európai Unió általános adatvédelmi rendelete,
        azaz a <strong>GDPR</strong> előírásai alapján kerül sor.
      </p>

      <h2>1. Az adatkezelő adatai</h2>
      <ul>
        <li><strong>Cégnév:</strong> FORTUNA PONYVA Kft.</li>
        <li><strong>Székhely:</strong> 2330 Dunaharaszti, Jedlik Ányos út 10.</li>
        <li><strong>Adószám:</strong> 12611353-2-13</li>
        <li><strong>Cégjegyzékszám:</strong> 13 09 133521</li>
        <li><strong>Weboldal:</strong> fortunaponyva.hu</li>
        <li><strong>Telefonszám:</strong> {COMPANY.phone}</li>
      </ul>

      <h2>2. Milyen adatokat kezelünk?</h2>
      <p>
        A weboldal használata és a kapcsolatfelvétel során az alábbi
        személyes adatok kezelése történhet:
      </p>
      <h3>Kapcsolatfelvétel esetén:</h3>
      <ul>
        <li>név,</li>
        <li>e-mail cím,</li>
        <li>telefonszám,</li>
        <li>üzenet tartalma,</li>
        <li>az érdeklődés vagy ajánlatkérés részletei.</li>
      </ul>
      <h3>Ajánlatkérés, megrendelés vagy szerződés teljesítése esetén:</h3>
      <ul>
        <li>név vagy cégnév,</li>
        <li>kapcsolattartói adatok,</li>
        <li>számlázási adatok,</li>
        <li>teljesítési vagy szállítási cím,</li>
        <li>megrendelt termékekkel vagy szolgáltatásokkal kapcsolatos adatok.</li>
      </ul>
      <h3>Weboldal használata során:</h3>
      <ul>
        <li>IP-cím,</li>
        <li>böngésző típusa,</li>
        <li>eszköz adatai,</li>
        <li>látogatás időpontja,</li>
        <li>cookie-azonosítók, amennyiben a weboldal sütiket használ.</li>
      </ul>

      <h2>3. Az adatkezelés céljai és jogalapjai</h2>
      <div className="overflow-x-auto">
        <table>
          <thead>
            <tr>
              <th>Adatkezelési cél</th>
              <th>Kezelt adatok</th>
              <th>Jogalap</th>
              <th>Megőrzési idő</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>Kapcsolatfelvétel, érdeklődések megválaszolása</td>
              <td>név, e-mail, telefonszám, üzenet</td>
              <td>jogos érdek vagy hozzájárulás</td>
              <td>az ügy lezárásától számított legfeljebb 1 év</td>
            </tr>
            <tr>
              <td>Ajánlatkérés kezelése</td>
              <td>név, elérhetőség, ajánlat részletei</td>
              <td>szerződés előkészítése</td>
              <td>ajánlat érvényességéig, illetve legfeljebb 1 év</td>
            </tr>
            <tr>
              <td>Megrendelés, szerződés teljesítése</td>
              <td>kapcsolattartási, számlázási és teljesítési adatok</td>
              <td>szerződés teljesítése</td>
              <td>szerződéses jogviszony fennállása alatt</td>
            </tr>
            <tr>
              <td>Számlázás</td>
              <td>számlázási név, cím, adószám, számlaadatok</td>
              <td>jogi kötelezettség</td>
              <td>számviteli szabályok szerint 8 év</td>
            </tr>
            <tr>
              <td>Jogi igények kezelése</td>
              <td>kapcsolódó ügyfél- és szerződéses adatok</td>
              <td>jogos érdek</td>
              <td>általános elévülési idő szerint jellemzően 5 év</td>
            </tr>
            <tr>
              <td>Weboldal biztonságos működtetése</td>
              <td>IP-cím, technikai adatok</td>
              <td>jogos érdek</td>
              <td>jellemzően legfeljebb 30 nap</td>
            </tr>
            <tr>
              <td>Statisztikai vagy marketing cookie-k használata</td>
              <td>cookie-azonosítók, látogatási adatok</td>
              <td>hozzájárulás</td>
              <td>a cookie típusától függően</td>
            </tr>
          </tbody>
        </table>
      </div>
      <p>
        A nem feltétlenül szükséges sütikhez — például statisztikai, marketing
        vagy remarketing cookie-khoz — előzetes hozzájárulás szükséges. A
        NAIH saját cookie-tájékoztatójában is külön kezeli a működéshez
        szükséges sütiket, és tájékoztatást ad azok funkciójáról.
      </p>

      <h2>4. Kik férhetnek hozzá az adatokhoz?</h2>
      <p>
        A személyes adatokhoz kizárólag az adatkezelő, illetve azok a
        közreműködők férhetnek hozzá, akiknek ez a feladatuk ellátásához
        szükséges.
      </p>
      <p>
        <strong>Lehetséges adatfeldolgozók:</strong>
      </p>
      <ul>
        <li>tárhelyszolgáltató,</li>
        <li>könyvelő,</li>
        <li>számlázóprogram szolgáltatója,</li>
        <li>informatikai szolgáltató,</li>
        <li>futárszolgálat vagy szállítást végző partner,</li>
        <li>online marketing vagy analitikai szolgáltató, ha ilyen szolgáltatás használatban van.</li>
      </ul>

      <h2>5. Adattovábbítás harmadik országba</h2>
      <p>
        Az adatkezelő alapvetően nem továbbít személyes adatokat az Európai
        Gazdasági Térségen kívülre.
      </p>
      <p>
        Amennyiben a weboldal Google, Meta, TikTok, YouTube vagy más külső
        szolgáltatásokat használ, előfordulhat, hogy egyes adatok harmadik
        országba kerülnek továbbításra. Ebben az esetben az adattovábbítás az
        adott szolgáltató adatvédelmi feltételei és a vonatkozó jogi
        garanciák alapján történik.
      </p>

      <h2>6. Az érintettek jogai</h2>
      <p>Az érintett jogosult:</p>
      <ul>
        <li>tájékoztatást kérni személyes adatai kezeléséről,</li>
        <li>hozzáférést kérni a kezelt személyes adatokhoz,</li>
        <li>kérni pontatlan adatainak helyesbítését,</li>
        <li>kérni adatainak törlését,</li>
        <li>kérni az adatkezelés korlátozását,</li>
        <li>tiltakozni jogos érdeken alapuló adatkezelés ellen,</li>
        <li>hozzájáruláson alapuló adatkezelés esetén a hozzájárulást visszavonni,</li>
        <li>panaszt tenni a felügyeleti hatóságnál.</li>
      </ul>
      <p>
        A <strong>NAIH</strong> a magyarországi adatvédelmi felügyeleti
        hatóság, amelynek feladata a személyes adatok védelméhez fűződő jogok
        érvényesülésének ellenőrzése.
      </p>

      <h2>7. Panasztételi lehetőség</h2>
      <p>
        Amennyiben úgy érzi, hogy személyes adatainak kezelése jogsértő,
        panasszal élhet az alábbi hatóságnál:
      </p>
      <ul>
        <li><strong>Nemzeti Adatvédelmi és Információszabadság Hatóság</strong></li>
        <li>Székhely: 1055 Budapest, Falk Miksa utca 9-11.</li>
        <li>Postacím: 1363 Budapest, Pf. 9.</li>
        <li>Weboldal: <a href="https://naih.hu" target="_blank" rel="noopener noreferrer">naih.hu</a></li>
      </ul>

      <h2>8. Adatbiztonság</h2>
      <p>
        Az adatkezelő megfelelő technikai és szervezési intézkedéseket
        alkalmaz annak érdekében, hogy a személyes adatok védettek legyenek a
        jogosulatlan hozzáféréssel, megváltoztatással, továbbítással,
        nyilvánosságra hozatallal, törléssel vagy megsemmisítéssel szemben.
      </p>

      <h2>9. A tájékoztató módosítása</h2>
      <p>
        Az adatkezelő fenntartja a jogot a jelen tájékoztató módosítására. A
        mindenkor hatályos változat a weboldalon érhető el.
      </p>
    </LegalPageLayout>
  );
}
